import { Box, Rating, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { minimumNumberOfLines } from './SummaryContent';

const classes = {
	flex: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	form: {
		marginY: 0.5,
	},
	icons: {
		marginLeft: 1,
	},
};

const AverageRating = ({ data, viewAll }) => {
	const { t } = useTranslation(['candidate-feedback']);
	const [slicedData, setSlicedData] = React.useState([]);

	React.useEffect(() => {
		if (viewAll) {
			const allData = [...data];
			setSlicedData(allData);
		} else {
			const smallerDataSet = data.slice(0, minimumNumberOfLines);
			setSlicedData(smallerDataSet);
		}
	}, [data, viewAll]);

	return React.Children.toArray(
		slicedData.map((question) => (
			<Box sx={{ ...classes.flex, alignItems: 'baseline' }}>
				<Box>
					<Typography variant="body1">
						{question.label}{' '}
						<span className="screenreader">
							:{' '}
							{t('average_rating_aria_label', {
								averageRating: Number(question.answerAverage.toFixed(1)),
							})}
						</span>
					</Typography>
				</Box>
				<Box sx={classes.flex} marginLeft={3} aria-hidden="true">
					<Typography variant="body1" sx={classes.form}>
						{Number(question.answerAverage.toFixed(1))}
					</Typography>
					<Rating
						name="read-only"
						value={Number(question.answerAverage.toFixed(1))}
						readOnly
						precision={0.1}
						size="small"
						aria-hidden="true"
						sx={{ marginLeft: 1, color: 'rgb(250, 175, 0)' }}
					/>
				</Box>
			</Box>
		)),
	);
};

export default AverageRating;
